import { render, staticRenderFns } from "./BotFilter.vue?vue&type=template&id=6806ed80&scoped=true&"
import script from "./BotFilter.vue?vue&type=script&lang=js&"
export * from "./BotFilter.vue?vue&type=script&lang=js&"
import style0 from "./BotFilter.vue?vue&type=style&index=0&id=6806ed80&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806ed80",
  null
  
)

export default component.exports